import http from "../http-common";
import authHeader from './auth-header';

class toolsService {

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PERIODS

runPeriodEnd(data) {
  return http.post("/tools/period_end", data, { headers: authHeader() });
}

  createPeriod(data) {
    return http.post("/tools/periods/create", data, { headers: authHeader() });
  }

  getAllPeriods() {
    return http.get("/tools/periods", { headers: authHeader() });
  }

  getSystemDate() {
    return http.get("/tools/system_date", { headers: authHeader() });
  }

  getPeriod(PeriodID) {
    return http.get(`/tools/periods/${PeriodID}`, { headers: authHeader() });
  }

  updatePeriod(PeriodID, data) {
    return http.put(`/tools/periods/update/${PeriodID}`, data, { headers: authHeader() });
  }

  deletePeriod(PeriodID) {
    return http.delete(`/tools/periods/delete/${PeriodID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION DEFAULTS

  getAllApplicationDefaults() {
    return http.get("/tools/application_defaults", { headers: authHeader() });
  }

  getAllBackdatingLimitPeriods() {
    return http.get("/tools/backdating_limits/periods", { headers: authHeader() });
  }

  getAllUnitsRounding() {
    return http.get("/tools/units_rounding", { headers: authHeader() });
  }

  updateApplicationDefaults(AppsDefaultsId, data) {
    return http.put(`/tools/application_defaults/update/${AppsDefaultsId}`, data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SYSTEM IDENTITY

  getIdentity() {
    return http.get("/tools/identity", { headers: authHeader() });
  }

  updateIdentity(OrgId, data) {
    return http.put(`/tools/identity/update/${OrgId}`, data, { headers: authHeader() });
  }
}

export default new toolsService();